import * as React from 'react';
type Props = {
  className?: string;
};
export function Fish({ className }: Props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 23 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="utility-fish"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.6165 7.32009C19.9125 7.47585 20.1 7.79187 20.1009 8.13795L20.125 15.3573C20.1259 15.6993 19.946 16.0135 19.657 16.1733C19.3679 16.334 19.0186 16.3134 18.7467 16.1195L16.6371 14.6157C15.6417 15.272 13.3824 16.5253 10.6495 16.5253C8.31409 16.5253 5.63323 15.6104 3.09691 12.6281C2.82719 12.3107 2.80052 11.8421 3.03238 11.4933C3.13262 11.3429 5.53558 7.79635 9.56203 7.11316C11.891 6.71815 14.2522 7.35825 16.5898 9.01865L18.6977 7.40044C18.9661 7.19575 19.3197 7.16433 19.6165 7.32009ZM16.0934 12.7816C16.3954 12.5334 16.8178 12.5168 17.1361 12.7448L18.357 13.6147L18.3449 9.95367L17.1198 10.8941C16.8066 11.1333 16.3807 11.1315 16.071 10.8905C13.9632 9.24938 11.8721 8.58773 9.85971 8.92529C7.45933 9.32703 5.70378 11.0588 4.92473 11.9736C10.2159 17.5029 15.8482 12.9827 16.0934 12.7816ZM6.91112 12.0572C6.89977 11.5162 7.31054 11.0676 7.82869 11.0557C8.34689 11.0429 8.77717 11.4721 8.78862 12.0131C8.79997 12.5542 8.38915 13.0028 7.87095 13.0147C7.35286 13.0274 6.92338 12.5983 6.91112 12.0572Z"
        fill="#214E33"
      />
    </svg>
  );
}
